import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import { AiOutlineSend } from 'react-icons/ai'
import { useSelector } from "react-redux";
import { IoIosAttach, IoMdCloseCircleOutline, IoMdDocument } from 'react-icons/io';
import { Link } from "react-router-dom";
import useAxiosFile from "../../actions/useaxios";
import { useLocation } from "react-router";
import { DateTimeForm, isEmpty, updateToast } from "../../actions/common";
import { socket } from "../../services/socket";
import { toast } from "react-toastify";
import config from "../../actions/config"
let Msg = []

function Chatbox() {
  const { toggle, payload, token } = useSelector(
    (state) => state.seller_panel.User
  );
  const axiosFile = useAxiosFile();

  const [textarea, setTextarea] = useState('');
  const [selectedFiles, setSelectedFiles] = useState([]);
  const chatRef = useRef(null);
  const attachref = useRef(null)
  const [anim, setAnim] = useState(false);
  const [typing, setTyping] = useState(false)
  const containerRef = useRef(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [Roomid, setRoomid] = useState('');
  const [message, setsendmessage] = useState([])
  const [sendMsg, setSendMsg] = useState('');


  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const oderId = queryParams.get("orderid");
  const receiverId = queryParams.get("receiverid");
  const scrollRef = useRef();



  const [chatlist, setChatlist] = useState([
    {
      type: "admin",
      message: "Hi Raja",
      date: "08.07.2024 11:00 am",

    },
    {
      type: "user",
      message: "Hi",
      date: "08.07.2024 11:00 am",

    }
  ])
  const sendmessage = () => {
    var date = `${new Date().getHours() > 12 ? `${new Date().getHours() - 12}` : new Date().getHours()}.${new Date().getMinutes()} ${new Date().getHours() >= 12 ? "PM" : "AM"}`
    var newchatlist = {
      type: "user",
      message: textarea,
      date: date,
      images: selectedImages

    }

    if (newchatlist.message || newchatlist.images) {
      setChatlist(previousArray => [...previousArray, newchatlist]);
      setTextarea('');
      var chatdiv = document.getElementById("chatheight");
      console.log(chatdiv, chatdiv.scrollTop, "chatdiv");

      chatdiv.scrollTop = chatdiv.scrollHeight + 300;
      // if (containerRef.current) {
      //   // console.log(chatRef.current.scrollHeight, "chatdiv");
      //   containerRef.current.scrollTop = containerRef.current.scrollHeight;
      // // chatRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
      // }
      setAnim(true)
      setSelectedImages('')
    }
    else {
      // toast.error("please enter message");
    }

  }
  const clickattach = () => {
    attachref.current.click();
  }
  const attachfile = (e) => {


    const files = Array.from(e.target.files);

    if (files?.length > 0 && files?.length + (selectedImages?.length ? selectedImages?.length : 0) < 5 &&
      [...files].some((it) => it.type.includes("image"))
    ) {
      let formData = [
        ...selectedImages,
        ...[...files].filter((it) => it.type.includes("image")),

      ]

      setSelectedImages(formData);
    }
    if (
      files?.length > 0 &&
      files?.length +
      (selectedImages?.length
        ? selectedImages?.length
        : 0) >
      4 &&
      [...files].some((it) => it?.type.includes("image"))
    ) {
      toast.error("Add Only 4 Images");
    }
    if (
      files?.length > 0 &&
      files?.length <= 4 &&
      [...files].some((it) => !it.type.includes("image"))
    ) {
      toast.error(
        "Exept Image Other types of files will be terminated",
      );
    }

    // setSelectedImages([...selectedImages, ...files]);
  }

  const removeImg = (i) => {
    let all = selectedImages;
    all.splice(i, 1)
    setSelectedImages([...all])
  }
  // const downloadpdf = (e) => {
  //   const pdfUrl = URL.createObjectURL(e);

  //   // Create an invisible link element
  //   const link = document.createElement('a');
  //   link.href = pdfUrl;
  //   link.setAttribute('download', 'downloaded.pdf');
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);

  // }


  useEffect(() => {
    socket.on("newMessage", (value) => {

      setsendmessage([...Msg, value?.message])
      Msg.push(value?.message)
      scrollRef.current?.scrollToEnd({
        y: 0,
        animated: true,
      });

    })
  }, [socket])



  useEffect(() => {
    Roomcreation()
  }, [])

  useEffect(() => {
    GetMessages()
  }, [sendMsg, socket])

  const MessageSend = async () => {
    if (isEmpty(Roomid)) {
      return toast.error("Room id must be provided")
    }
    let message = await axiosFile.sendMessage({
      receiverId: receiverId,
      orderId: oderId,
      message: textarea,
      messageType: "text",
      roomId: Roomid,
      images: selectedImages
    })
    setTextarea('')
    GetMessages()
    setSelectedImages([])
    scrollRef.current?.scrollToEnd({
      y: 0,
      animated: true,
    });
    // if(sendMsg.length > 0){
    //   setSendMsg('');
    //   scrollRef.current?.scrollToEnd({
    //     y: 0,
    //     animated: true,
    //   });
    // }

  }

  const Roomcreation = async () => {
    let chatroom = await axiosFile.createRoom({ id: receiverId, orderId: oderId })
    setRoomid(chatroom?.data?.roomId)
  }

  const GetMessages = async () => {
    let chatmessage = await axiosFile.getMessage({ receverId: receiverId, orderId: oderId })
    Msg = chatmessage?.data ?? []
    setsendmessage(chatmessage?.data)
  }


  return (
    <section
      id="content-wrapper"
      // style={{ marginTop: "30px" }}
      className=" dly_rpt_inr support_ticketPage"
    >

      <div class="row mx-auto">

        <div className="col-12 col-xl-3  d-flex align-items-start align-items-xl-center gap-4">
          <Link to={'/chatlists'} className="viewbtn" >Back</Link>
          <p className="page_title mb-0">Chat</p>
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <div className='chatcard'>
            <div className='chat_topsec'
              ref={containerRef}
              id="chatheight"
            >
              {message?.map((e, i) => (
                <div className={`chat_details d-flex gap-2 align-items-start flex-row mb-3 m-auto ${e?.user == "sender" && "flex-row-reverse"} ${i == chatlist.length - 1 && e.type == "user" && "chatanimuser"}
                    ${i == chatlist.length - 1 && e?.user == "receiver" && "chatanimadmin"}`}>
                  {console.log(chatlist.length - 1, 'animss')}
                  <div>
                    {/* <img src={adminpf} className='img-fluid pf_img' alt='admin profile' /> */}
                  </div>
                  <div className={`d-flex flex-column ${e?.user == "sender" && "align-items-end"}`}>

                    <div className={`${e?.user == "receiver" && 'senderbg'} chat_message`}>
                      {e?.attachments?.length > 0 &&

                        <>
                          <div className='d-flex align-items-center gap-2 flex-wrap'>
                            {e.attachments.map((imgs) => (
                              imgs?.types ?
                                <div className='mb-3'>
                                  {
                                    imgs?.type?.includes("image") ?
                                      <a href={URL.createObjectURL(imgs)} target="_blank" className='text-decoration-none'>
                                        <div className='imgsec '>
                                          <img src={URL.createObjectURL(imgs)} className='img-fluid selected_img' alt={imgs.name} />

                                        </div>
                                      </a>
                                      :
                                      imgs?.type.includes("video") ?
                                        <a href={URL.createObjectURL(imgs)} target="_blank" className='text-decoration-none'>
                                          <div className='videosec '>

                                            <video src={URL.createObjectURL(imgs)} className="img-fluid selected_video" />

                                          </div>
                                        </a>
                                        :
                                        <a href={URL.createObjectURL(imgs)} className="text-white text-decoration-none" target="_blank" >
                                          <div key={i} className='docsec'
                                          >

                                            <IoMdDocument fill='#000' fontSize={24} style={{ width: "50px" }} />
                                            <p className='docname'>{imgs.name}</p>
                                          </div>
                                        </a>
                                  }
                                </div>
                                :
                                <div className='mb-3 displayimgsec'>


                                  <img
                                    src={`${config.IMG_URL}/chats/${imgs}`}
                                    alt="logo"
                                    width="100%"
                                    className="displayimg_img"

                                  />

                                </div>
                            ))}
                          </div>



                        </>
                      }
                      {e?.message &&
                        <div >
                          <p className={`para ${e.user == "user" && "text-end"}`}>{e?.message}</p>
                        </div>
                      }


                    </div>
                    <p className='datetime'>{DateTimeForm(new Date(e?.createdAt), false, true, true)}</p>
                  </div>

                </div>
              ))}
              {typing &&
                < div className="is-typing">
                  <div className="jump1"></div>
                  <div className="jump2"></div>
                  <div className="jump3"></div>
                </div>
              }
              <div
                ref={chatRef}
                className='pb-5'></div>


            </div>
            <div className='chat_inpsec'>
              {selectedImages?.length > 0 &&
                <div className='attachsec'>
                  <div className='d-flex align-items-center gap-2 flex-row attachsecrow'>

                    {selectedImages.map((e, i) => (
                      <>
                        {e?.type?.includes("image") ?
                          <>

                            <div key={i} className='imgsec'>
                              <img src={URL.createObjectURL(e)} className='img-fluid selected_img' alt={e.name} />
                              <IoMdCloseCircleOutline fill='#fff' className="closeicon" onClick={() => removeImg(i)} />
                            </div>

                          </>
                          :
                          e.type.includes("video") ?
                            <>

                              <div className='videosec '>

                                <video src={URL.createObjectURL(e)} className="img-fluid selected_video" />
                                <IoMdCloseCircleOutline fill='#fff' className="closeicon" onClick={() => removeImg(i)} />

                              </div>

                            </>
                            :

                            <>

                              <div key={i} className='docsec'>
                                <IoMdDocument className="h-25 text-dark" fill='#fff' style={{ width: "50px" }} />
                                <p className='docname'>{e.name}</p>
                                <IoMdCloseCircleOutline fill='#fff' className="closeicon" onClick={() => removeImg(i)} />
                              </div>

                            </>

                        }
                      </>
                    ))}
                  </div>
                </div>
              }
              <div className="input-group mb-3">
                <textarea className="form-control" aria-label="With textarea"
                  onFocus={() => setTyping(true)}
                  onBlur={() => setTyping(false)}
                  onKeyDown={(e) => (e?.key === 'Enter' && !e?.ctrlKey ? MessageSend() : null)}
                  value={textarea} onChange={(e) => setTextarea(e.target.value)}></textarea>
                <span className="input-group-text d-flex gap-2" id="basic-addon2">
                  <div className='send_icon' onClick={clickattach}>
                    <IoIosAttach fontSize={24} />
                    <input
                      multiple
                      ref={attachref}
                      type="file"
                      className="d-none"
                      onChange={(e) =>
                        attachfile(e)

                      }
                    />
                  </div>
                  <div className='send_icon' onClick={MessageSend}>
                    <AiOutlineSend fontSize={24} />
                  </div>
                </span>
              </div>
            </div>


          </div>

        </div>

      </div>

    </section>
  );
}

export default Chatbox;
